import React, { useState, useEffect } from 'react';

import { Select } from '~/componentes/CustomForm';
import { Container, ThisCard, ThisCalendar, ScrollOS } from './styles';

function CustomBodyContent({ data, anos, anoAtivo, setAnoAtivo, mesNumAtivo, setMesNumAtivo }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [mesAtivo, setMesAtivo] = useState({ id: mesNumAtivo, list: [] });

  useEffect(() => {
    if (data?.length > 0) {
      let item = data?.find(e => e?.id == mesAtivo?.id);
      setMesAtivo(item ? item : { id: new Date().getMonth() + 1, list: [] });
    }
  }, [data]);

  useEffect(() => {
    if (mesNumAtivo != mesAtivo?.id) {
      setMesNumAtivo(mesAtivo?.id);
    }
  }, [mesAtivo]);

  return (
    <Container>
      <div className="content-os">
        <ScrollOS>
          {mesAtivo?.list?.length > 0 &&
            mesAtivo?.list?.map((thisData, i) => (
              <ThisCard
                className={linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'}
                {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
                key={thisData?.id || i}
                id={thisData?.id || i}
                index={i}
                ativo={linhaAtiva === thisData?.id ? true : false}
              >
                <div className="top">
                  <div className="content-top">
                    <div className="card-cod">
                      <p className="cod">#{thisData?.id}</p>
                    </div>
                    <div className="card-top">
                      <p className="titulo">{thisData?.titulo}</p>
                      <p className="analista">{thisData?.analista}</p>
                    </div>
                  </div>
                  <div className="info">
                    <p className="data">{thisData?.data}</p>
                    <p className="projeto">{thisData?.projeto}</p>
                    <p className="cliente">{thisData?.cliente}</p>
                  </div>
                </div>
                <div className="content-os">
                  <div className="horario">
                    {thisData?.horas?.map((thisHora, a) => (
                      <div className="item-hora" key={a}>
                        <div className="card-numero">
                          <p className="numero">{a + 1}</p>
                        </div>
                        <div className="card-hora">
                          <p className="hora">
                            {thisHora?.horaInicialMascara} - {thisHora?.horaFinalMascara}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="totalizadores">
                    <p className="desconto">Desconto: {thisData?.desconto}h</p>
                    <p className="translado">Translado: {thisData?.translado}h</p>
                    <div className="card-total">
                      <p className="total">Total: {thisData?.total}h</p>
                    </div>
                  </div>
                </div>
              </ThisCard>
            ))}
        </ScrollOS>
      </div>
      <ThisCalendar>
        <div className="calendario">
          <Select
            isNumber
            list={{
              list: anos,
              value: 'id',
              label: 'id',
            }}
            name="anoAtivo"
            defaultValue={anoAtivo}
            onChange={e => {
              const v = e.currentTarget.value || 2023;

              setAnoAtivo(v);
            }}
          />
          <div className="meses">
            {data?.length > 0 &&
              data?.map((thisData, i) => (
                <div
                  onClick={() => setMesAtivo(thisData)}
                  className={thisData?.id == mesAtivo?.id ? 'mes' : 'mes-desativo'}
                  key={i}
                >
                  <p className="titulo-mes">{thisData?.sigla}</p>
                  <p className="ano">{thisData?.ano}</p>
                </div>
              ))}
          </div>
        </div>
      </ThisCalendar>
    </Container>
  );
}

export default CustomBodyContent;
